import { inject } from '@angular/core';
import { of, take, tap } from 'rxjs';
import { PostfachService } from '../services/apiservices/postfach.service';
import { UserAccountService } from '../services/user-account.service';


export const rechteResolver = () => {
    const userAccountService = inject(UserAccountService);


    if (userAccountService.hasUserAccount()) {
        return of(userAccountService.getUserAccount()).pipe(take(1));
    }


    return inject(PostfachService)
        .postBenutzerkonto()
        .pipe(
            tap(acc => userAccountService.setUserAccount(acc)),
            take(1)
        );
};